<template>
    <el-container class="authorization is-vertical">
        <!--TODO 推播開-->
        <el-row class="block receive" type="flex" justify="space-between" v-show="isNotificationPermission">
            <el-col :span="20">
                <img src="@/assets/images/setting/bell.svg">
                <span>接收推播</span>
            </el-col>
            <el-col :span="4" class="text-right">
                <el-button type="text" class="check" icon="el-icon-circle-check"/>
            </el-col>
        </el-row>
        <!--TODO 推播關-->
        <div class="block camera" v-show="!isNotificationPermission">
            <div>
                <img src="@/assets/images/setting/bell_black.svg">
                <span>接收推播</span>
            </div>
            <div class="text">
                開啟推播通知功能，可獲得最新最優惠的第一手消息及好友們的動態資訊！
            </div>
            <div class="text-right">
                <el-button type="text" @click.native="onClickSetting">你已拒絕，由此前往開啟設定 ></el-button>
            </div>
        </div>

        <!--TODO 相機開-->
        <el-row class="block receive" type="flex" justify="space-between" v-show="isCameraPermission">
            <el-col :span="20">
                <img src="@/assets/images/setting/camera.svg">
                <span>取用您的相機</span>
            </el-col>
            <el-col :span="4" class="text-right">
                <el-button type="text" class="check" icon="el-icon-circle-check"/>
            </el-col>
        </el-row>
        <!--TODO 相機關-->
        <div class="block camera" v-show="!isCameraPermission">
            <div>
                <img src="@/assets/images/setting/camera_black.svg">
                <span>取用您的相機</span>
            </div>
            <div class="text">
                開啟相機功能，可用來掃描 RQCODE 加入好友，掃描候位及消費支付
            </div>
            <div class="text-right">
                <el-button type="text" @click.native="onClickSetting">你已拒絕，由此前往開啟設定 ></el-button>
            </div>
        </div>


        <!--TODO 所在位置開-->
        <el-row class="block receive" type="flex" justify="space-between" v-show="isLocationPermission">
            <el-col :span="20">
                <img src="@/assets/images/setting/location.svg">
                <span>取用您的所在位置</span>
            </el-col>
            <el-col :span="4" class="text-right">
                <el-button type="text" class="check" icon="el-icon-circle-check"/>
            </el-col>
        </el-row>
        <!--TODO 所在位置關-->
        <div class="block camera" v-show="!isLocationPermission">
            <div>
                <img src="@/assets/images/setting/location_black.svg">
                <span>取用您的所在位置</span>
            </div>
            <div class="text">
                同意取得您的所在位置，可讓OIN串門子提供您最近及適合的店家給您。
            </div>
            <div class="text-right">
                <el-button type="text" @click.native="onClickSetting">你已拒絕，由此前往開啟設定 ></el-button>
            </div>
        </div>
    </el-container>
</template>

<script>
    export default {
        name: "Authorization",
        data() {
            return {
                isLocationPermission: false,
                isCameraPermission: false,
                isNotificationPermission: false,
                isContactPermission: false,
            }
        },
        created() {

        },
        mounted() {
            this.getLocationPermission();
            this.getCameraPermission();
            this.getContactPermission();
            this.getNotificationPermission();
        },
        methods: {


            /** 點擊 設定 */
            onClickSetting: function() {
                this.goSettingPage();
            },

            /** 前往 app設定頁 */
            goSettingPage: function () {
                let os = this.$http.getOS();
                if ( os === 'Android' || os === 'iOS') {
                    if (this.$public.notNull(window.cordova)) {
                        let customPlugin = window.cordova.plugins.CustomUtilPlugin;
                        customPlugin.openSettingPage();
                    }
                }

            },

            /** 檢查定位權限 */
            getLocationPermission: function() {
                let self = this;
                let os = this.$http.getOS();
                if ( os === 'Android' || os === 'iOS') {
                    if (this.$public.notNull(window.cordova)) {
                        let customPlugin = window.cordova.plugins.CustomUtilPlugin;
                        customPlugin.checkLocationPermission(result => {
                            self.isLocationPermission = result;
                        });
                    }
                }
            },

            /** 檢查聯絡人權限 */
            getContactPermission: function() {
                let self = this;
                let os = this.$http.getOS();
                if ( os === 'Android' || os === 'iOS') {
                    if (this.$public.notNull(window.cordova)) {
                        let customPlugin = window.cordova.plugins.CustomUtilPlugin;
                        customPlugin.checkContactPermission(result => {
                            self.isContactPermission = result;
                        });
                    }
                }
            },

            /** 檢查相機權限 */
            getCameraPermission: function() {
                let self = this;
                let os = this.$http.getOS();
                if ( os === 'Android' || os === 'iOS') {
                    if (this.$public.notNull(window.cordova)) {
                        let customPlugin = window.cordova.plugins.CustomUtilPlugin;
                        customPlugin.checkCameraPermission(result => {
                            self.isCameraPermission = result;
                        });
                    }
                }
            },

            /** 檢查推播權限 */
            getNotificationPermission: function() {
                let self = this;
                let os = this.$http.getOS();
                if ( os === 'Android' || os === 'iOS') {
                    if (this.$public.notNull(window.cordova)) {
                        let customPlugin = window.cordova.plugins.CustomUtilPlugin;
                        customPlugin.checkNotificationPermission(result => {
                            self.isNotificationPermission = result;
                        });
                    }
                }
            },

        }
    }
</script>